/* eslint-disable complexity */
// 设置展开栏创建群组

import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "./index.less";
import IconFont from "@/components/icon";
import { useTranslation } from "react-i18next";
import { Employee, Session, SessionProps, ChatMessage } from "@/types/chat";
import {
  employeeToUid,
  isCrossPlatformGroupSession,
  isEqualEmployee,
  isGroupSetAlias,
  isShieldSession
} from "@/utils/chat/message";
import { getUserAlias, isGroupAdmin, isGroupOwner } from "@/utils/chat/group";
import { SessionSettingsType } from "@/types/chat/enum";
// import useUserSelector from '@/components/chat/GroupUserSelector';
import GroupManager, {
  GroupSettingItem,
  SettingSwitch
} from "@/components/chat/SessionSettingV2/GroupManager";
import GroupBotsManager from "./GroupBotsManager";
import Context from "@/components/chat/context";
import ChatState from "@/types/chat/State";
import { connect } from "dva";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { teamCreates, spaceCreate, groupCreates } from "@/components/Joyspace/api";
import { Modal, message, Input, Button, Switch, Divider } from "antd";
import { FocusSDK, isFocusEnv } from "@/utils";
import { isAINoticeSession, isCustomAppSession } from "@/utils/chat/session";
import { duccConfigI18 } from "@/utils/i18n";
import NetworkCheck, { UseCheckType } from "@/utils/NetworkCheck";
// eslint-disable-next-line no-duplicate-imports
import { getNetCheckUrl } from "@/config/config";
import i18n from "@/i18n";
import Bus from "@/utils/bus";
import { sessionSetting } from "@/server/im/SessionService";
import ConcernedGroupMembers from "./ConcernedGroupMembers";

const netServer = NetworkCheck.getInstance({
  url: getNetCheckUrl(),
  checkType: UseCheckType.API
});
import colors from "@/components/styles/colors";
import ImService from "@/server/ImService";
import { getGroupMemberList, queryUserAlias, delCustomAppConfig } from "@/api/chat";
import events from "@/components/Joyspace/context/events";
import { crossAppSwitch } from "@/utils/tools";
import {
  useHandleContextMenuClick
} from "@/components/chat/Session/common";
import { ClickParam } from "antd/lib/menu";
import { unknown } from "@/assets/images/joyspace";
const { TextArea } = Input;
// 导入新的 CreateGroupButton 组件
import CreateGroupButton from "@/components/chat/CreateGroupButton";

interface Props {
  selectedSession: SessionProps;
  openSetup: boolean;
  sessionMembers: Partial<Employee>[];
  newSession: any;
  customAppList: Session[];
  updateSelectedSession: Function;
  clearSessionMessage: Function;
}

type IProps = Readonly<Props>;

function CreateGroup(props: IProps) {
  const { selectedSession } = props;
  const { currentEmployee } = React.useContext(Context);
  const { t } = useTranslation("chat");

  // const createGroup = useUserSelector({
  //     selectedSession,
  //     currentEmployee,
  //     groupRosters: [],
  //     sessionMembers,
  //     userData,
  // });

  if (selectedSession.isSingle && !selectedSession.isNotice) {
    // 自聊
    const info = selectedSession.info as Employee;
    if (isEqualEmployee(info, currentEmployee)) {
      return null;
    }
    // 2020-09-22 关闭非一租户不可以创建群聊，支持外部群 跨平台群
    // // 不是同一租户
    // if (!isEqualTeam(info, currentEmployee)) {
    //     return null;
    // }
    // return (
    //     <div
    //         className="create"
    //         onClick={createGroup}
    //         clstag="pageclick|keycount|focus_chat_01_1615797500283|71"
    //     >
    //         <IconFont type="iconapp_btn_more" className="create_img" />
    //         <button>{t('create_group')}</button>
    //     </div>
    // );
  }

  return null;
}

function GroupManagerEntry(props: IProps) {
  const { selectedSession, openSetup, sessionMembers } = props;
  const [groupManagerVisible, setGroupManagerVisible] = useState(false);
  const { t } = useTranslation("chat");

  useEffect(() => {
    if (!openSetup) {
      setGroupManagerVisible(false);
    }
  }, [openSetup]);

  if (!selectedSession.isGroup) {
    return null;
  }

  return (
    <div>
      {/* 群管理入口 */}
      <GroupSettingItem
        title={t("group_management")}
        onClick={() => {
          setGroupManagerVisible(true);
        }}
        clstag="pageclick|keycount|Xtbg_Msg_Setting|GroupManageMent"
      >
        <IconFont
          type="iconFrame6"
          className="group-management-icon-arrow"
          onClick={() => {
            setGroupManagerVisible(true);
          }}
          clstag="pageclick|keycount|Xtbg_Msg_Setting|GroupManageMent"
        />
      </GroupSettingItem>
      {/* 弹出群管理页签 */}
      <GroupManager
        selectedSession={selectedSession}
        sessionMembers={sessionMembers}
        visible={groupManagerVisible}
        onClose={() => {
          setGroupManagerVisible(false);
        }}
      />
    </div>
  );
}

function GroupRobotEntry(props: IProps) {
  const { selectedSession, openSetup, sessionMembers } = props;
  const [groupRobotVisible, setGroupRobotVisible] = useState(false);
  const { t } = useTranslation("chat");

  useEffect(() => {
    if (!openSetup) {
      setGroupRobotVisible(false);
    }
  }, [openSetup]);

  if (!selectedSession.isGroup) {
    return null;
  }

  return (
    <div>
      {/* 组机器人入口 */}
      <GroupSettingItem
        title={t("group_robot")}
        onClick={() => {
          setGroupRobotVisible(true);
        }}
        clstag="pageclick|keycount|Xtbg_Msg_Setting|GroupManageMent"
      >
        <IconFont
          type="iconFrame6"
          className="group-management-icon-arrow"
          onClick={() => {
            setGroupRobotVisible(true);
          }}
          clstag="pageclick|keycount|Xtbg_Msg_Setting|GroupManageMent"
        />
      </GroupSettingItem>
      {/* 弹出群管理页签 */}
      <GroupBotsManager
        selectedSession={selectedSession}
        sessionMembers={sessionMembers}
        visible={groupRobotVisible}
        onClose={() => {
          setGroupRobotVisible(false);
        }}
      />
    </div>
  );
}

/**
 * 会话设置主入口
 * @param props
 * @constructor
 */
function SessionSetting(props: IProps) {
  const { selectedSession, newSession, customAppList, updateSelectedSession, clearSessionMessage } = props;
  const { groupRosterIdentity, currentEmployee, groupRosters, closeSetting } = React.useContext(
    Context
  );
  const { appRuntimeEnv } = React.useContext<GlobalContextConfig>(GlobalContext);
  const { t } = useTranslation("chat");
  const owner = (selectedSession as any)?.info || {};
  const { gid } = owner;
  const gname = owner.name;
  const description = owner.intro;
  const isUserSelf =
    currentEmployee.teamId === owner.teamId && currentEmployee.userId === owner.userId;
  const isGroup = selectedSession.isGroup;
  const history = useHistory();
  const isOutAppGroup = isCrossPlatformGroupSession(selectedSession);
  const crossAppStyle = isOutAppGroup
    ? {
        opacity: 0.5,
        cursor: "not-allowed"
      }
    : {};

  // 组昵称相关数据
  // const [userAlias, setUserAlias] = useState('');
  const [alias, setAlias] = useState("");
  const [visibleView, setVisibleView] = useState(false);
  const [saving, setSaving] = useState(false);

  // console.log(
  //     'owenrowenrowenrowenr',
  //     newSession?.sessionId,
  //     newSession?.settings,
  //     selectedSession.sessionId,
  //     selectedSession?.settings
  // );
  const launchGroupSpace = useCallback(async () => {
    const onLine = await netServer.checkNet();
    if (isOutAppGroup) {
      return;
    }
    if (!onLine) {
      message.error(i18n.t("Network Error"));
      return;
    }
    let groupList = groupRosters;
    try {
      if (Array.isArray(groupList) && !groupList.length) {
        const { data } = await getGroupMemberList(gid, "group");
        groupList = data || [];
      }
      console.log("群组信息", groupList);
      if (!groupList.length) {
        message.error("该群已解散");
        // return;
      }

      let admins: any = [];
      for (let item of groupList) {
        if (item.identity === "administrator" || item.identity === "sub_administrator") {
          admins.push((item as any).info.userId);
        }
      }
      let result = await groupCreates({
        admins,
        folderId: gid,
        name: gname,
        description,
        parent: "groupRoot"
      });
      if (!result || result.errMsg) {
        message.error("create_group_team_space_error");
        // return;
      }
      events.emit("joyspace.groupSpace", {
        visible: true,
        gname: gname,
        gid: gid
      });
      setVisibleView(false);
      setAlias("");
      closeSetting?.();
    } catch (e) {
      console.error(e, "=asdadadasdadasdad");
      e && message.error(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupRosters, t]);
  // const launchGroupSpace = useCallback(async () => {
  //     console.log('组空间点击');
  //     try {
  //         let gid = owenr.gid;
  //         let gname = owenr.name;
  //         let gavatar = owenr.avatar;
  //         let gownerId = owenr.owner?.pin;
  //         let description = owenr.intro;
  //         let admins: any = [];
  //         for (let item of groupRosters) {
  //             if (item.identity === 'administrator' || item.identity === 'sub_administrator') {
  //                 admins.push((item as any).info.userId);
  //             }
  //         }
  //         let result = await groupCreates({
  //             admins,
  //             folderId: gid,
  //             // team_id: gid,
  //             name: gname,
  //             // avatar_url: gavatar,
  //             // adminUid: gownerId,
  //             // type: 1,
  //             description,
  //             parent: 'groupRoot',
  //         });
  //         if (result?.errMsg) {
  //             throw t('create_group_team_space_error');
  //         }
  //         if (result?.errMsg) {
  //             throw t('create_group_team_space_error');
  //         }
  //         FocusSDK.printLog('云空间', '云空间按钮点击--start');
  //         // console.log('关闭组空间', gid, gname, selectedSession, owenr);
  //         events.emit('joyspace.groupSpace', {
  //             visible: true,
  //             gname: gname || selectedSession.name,
  //             gid: gid,
  //             categoryId: selectedSession.id,
  //         });
  //         setVisibleView(false);
  //         setAlias('');
  //         closeSetting?.();
  //     } catch (e) {
  //         // FocusSDK.printLog('云空间--error', e.toString());
  //         e && message.error(e);
  //     }
  // }, [owenr, selectedSession, closeSetting, groupRosters, t]);

  // const getCurrentEmployeeAlias = useCallback(() => {
  //     queryUserAlias(selectedSession.id, [employeeToUid(currentEmployee)])
  //         .then((result) => {
  //             const alias = result[0] ? result[0].memberAliasList[0]?.alias : '';
  //             setUserAlias(alias);
  //         })
  //         .catch((e) => {
  //             console.log('queryUserAlias--err', e);
  //         });
  // }, [selectedSession, currentEmployee]);

  // useEffect(() => {
  //     getCurrentEmployeeAlias();
  // }, [getCurrentEmployeeAlias]);

  const openGroupAliasModal = () => {
    const alias = getUserAlias(currentEmployee, selectedSession, "set");
    setAlias(alias);
    setVisibleView(true);
  };

  const handleChangeGroupAlias = (e: any) => {
    setAlias(e.target.value);
  };
  const handleUpdateGroupAlias = () => {
    setAlias(alias);
    setVisibleView(false);
  };
  // 点击确定修改组昵称
  const confirmEditAlias = async () => {
    if (saving || !visibleView) {
      return;
    }
    const reg = /^[\u4e00-\u9fa5_a-zA-Z0-9-\/]+$/;
    if (alias && !reg.test(alias)) {
      message.warning("仅支持中文、数字、英文，下划线、减号、左斜杠");
      return;
    }
    setSaving(true);
    const instance = ImService.getInstance();
    const result = await instance.setGroupAlias(selectedSession.id, alias);
    if (result) {
      setSaving(false);
      setVisibleView(false);
      setAlias("");
    } else {
      message.info(t("failed"));
      setSaving(false);
    }
  };
  const modalFooter = (
    <div>
      <Button
        style={{
          border: "1px solid #dee0e3",
          borderRadius: " 4px",
          color: `${colors.black2}`
        }}
        className="cancelBtn"
        onClick={() => {
          setVisibleView(false);
          setAlias("");
        }}
      >
        {t("cancelText")}
      </Button>

      <Button
        type="primary"
        style={{
          border: "none",
          background: "@primary-color",
          borderRadius: "4px",
          fontSize: "14px",
          color: "#ffffff"
        }}
        onClick={confirmEditAlias}
      >
        {t("determine")}
      </Button>
    </div>
  );

  const handleJoinAi = () => {
    const session = { ...selectedSession };
    delCustomAppConfig({
      appKey: (session.info as any).userId,
      appName: (session.info as any).name
    }).then((res) => {
      if (res) {
        (session as any).isCustomApp = false;
        updateSelectedSession({ selectedSession: {} });  
        window.history.pushState({}, "", "/messages");
        Bus.emit("chat:session-update", session);
        // 聚合到AI助手后，需要取消置顶状态
        sessionSetting(SessionSettingsType.TOP, selectedSession.sessionId, false);
      }
    });
  };
  // 原始处理器
  const originalHandler = useHandleContextMenuClick({
      sessionId: selectedSession.sessionId,
      selectedSessionId: selectedSession.sessionId,
      t,
      clearSessionMessage,
      history,
      msg: selectedSession?.lastMsg as ChatMessage,
      session: selectedSession
    });


  const handleDeleteRecordClick = () => {
    const e: ClickParam = {
      key: "empty",
      keyPath: [],
      item: null,
      domEvent: new MouseEvent('click')
    };
    return originalHandler(e);
  };

  return (
    <div className="group-settings">
      {/* 创建群组 */}
      {/* <CreateGroup {...props} /> */}
      {/* 群管理入口 */}
      {isGroupOwner(groupRosterIdentity) || isGroupAdmin(groupRosterIdentity) ? (
        <GroupManagerEntry {...props} />
      ) : (
        crossAppSwitch("messageRecord") && selectedSession.isGroup &&
        !isCrossPlatformGroupSession(selectedSession) && (
          <>
           <GroupSettingItem
            title={t("group_record_clean")}
            onClick={() => {
              Bus.emit("recordClean:open", true);
            }}
          >
            <IconFont type="iconFrame6" className="group-management-icon-arrow" />
          </GroupSettingItem>
          <Divider style={{margin: "0 auto", color: "#DBDBDC99", width: "90%", minWidth: "90%"}} />
          </>
         
        )
      )}
      
      {/* 组空间 放到外层*/}
      {/* {isGroup && crossAppSwitch("groupSpace") && (
        <GroupSettingItem
          title={t("group_team_space")}
          clstag="pageclick|keycount|Xtbg_Msg_Setting|GroupSpace"
          onClick={launchGroupSpace}
          style={crossAppStyle}
        >
          <IconFont
            type="iconjs_ilist_arrowright"
            className="group-team-space-icon-arrow"
            clstag="pageclick|keycount|Xtbg_Msg_Setting|GroupSpace"
            style={crossAppStyle}
          />
        </GroupSettingItem>
      )} */}
      {/* 组机器人 */}
      <GroupRobotEntry {...props} />
      {/* 群昵称样式改造 */}
      {isGroupSetAlias(selectedSession) && (
        <>
          <div className="group-alias group-management-item">
            <div className="group-alias_label group-management-item-title">群昵称</div>
            <div className="group-alias_content" onClick={openGroupAliasModal}>
              <span className="name">
                {getUserAlias(currentEmployee, selectedSession, "set") || "未设置"}
              </span>
              <div className="group-alias-edit-icon">
                 <IconFont type="iconbianji1" />
              </div>
            </div>
          </div>
          <div className="group-alias-input">
            {visibleView && <Input
              value={alias}
              autoFocus
              maxLength={20}
              // onChange={searchName}
              // onFocus={() => analysisLog("Xtbg_Msg_Setting", "SearchMember")}
              onChange={handleChangeGroupAlias}
              onBlur={confirmEditAlias}
              placeholder={
                getUserAlias(currentEmployee, selectedSession, "set")
                  ? "请输入在本群的昵称"
                  : ""
              }
            />}
           </div>
            <Divider style={{margin: "0 auto 6px auto", color: "#DBDBDC99", width: "90%", minWidth: "90%"}} />
        </>
      )}
     
      {/* 置顶 */}
      <GroupSettingItem checkboxStyle={true} boldTitle={false} title={t("add_to_top")}>
        <SettingSwitch
          checkboxStyle={true}
          selectedSession={selectedSession}
          type={SessionSettingsType.TOP}
          clsTag={[
            `pageclick|keycount|${
              isAINoticeSession(selectedSession) ? "Xtbg_Msg_AI" : "Xtbg_Msg_Setting"
            }|SetTop_True`,
            `pageclick|keycount|${
              isAINoticeSession(selectedSession) ? "Xtbg_Msg_AI" : "Xtbg_Msg_Setting"
            }|SetTop_False`
          ]}
        />
      </GroupSettingItem>
      {/* 消息提醒 */}
      {!isAINoticeSession(selectedSession) && !isUserSelf && (
        <GroupSettingItem checkboxStyle={true} boldTitle={false} title={t("message_remind")}>
          <SettingSwitch
          checkboxStyle={true}
            selectedSession={
              newSession?.sessionId !== selectedSession.sessionId ? selectedSession : newSession
            }
            type={SessionSettingsType.SHIELD}
            clsTag={[
              `pageclick|keycount|${
                isAINoticeSession(selectedSession) ? "Xtbg_Msg_AI" : "Xtbg_Msg_Setting"
              }|SetRemind_True`,
              `pageclick|keycount|${
                isAINoticeSession(selectedSession) ? "Xtbg_Msg_AI" : "Xtbg_Msg_Setting"
              }|SetRemind_False`
            ]}
          />
        </GroupSettingItem>
      )}

      {/* 显示成员昵称 */}
      {isGroupSetAlias(selectedSession) && <GroupSettingItem checkboxStyle={true} boldTitle={false} title={t("display_alias")}>
        <SettingSwitch
        checkboxStyle={true}
          selectedSession={selectedSession}
          type={SessionSettingsType.DISPLAY_ALIAS}
        />
      </GroupSettingItem>}
      
      {/* 关注的组成员 */}
      {isGroup && isShieldSession(selectedSession) && <ConcernedGroupMembers />}
      
      {/* 聚合到AI助手 */}
      {isCustomAppSession(selectedSession, customAppList) && (
        <GroupSettingItem title={t("join_ai_robot")} desc="若打开此开关，该应用通知会出现在AI助手">
          <Switch onClick={handleJoinAi} />
        </GroupSettingItem>
      )}
      <Divider style={{ margin: "0 auto", color: "#DBDBDC99", width: "90%", minWidth: "90%" }} />
      {selectedSession.isSingle &&
          <CreateGroupButton
            className="add_user"
            // 可以添加自定义 clstag
            clstag={selectedSession.isSingle
              ? "pageclick|keycount|Xtbg_Msg|AddMemberIcon_Single"
              : "pageclick|keycount|Xtbg_Msg|AddMemberIcon_Group"
            }
            customDisplayElement={
              <>
              <div className="create-group-in-single-chat">
                <IconFont type="iconchuangjianqunzu" />
                <span className="operation-text">创建群组</span>
              </div>
              <Divider style={{ margin: "0 auto", color: "#DBDBDC99", width: "90%", minWidth: "90%" }} />
              </>
            }
          />
      }
      
      <div className="clean-message-record" onClick={handleDeleteRecordClick}>
        <IconFont
          type="iconquanjushanchu"
        />
        <span className="operation-text">清空消息记录</span>
      </div>


      <Modal
        centered={true}
        title={<span style={{ fontWeight: "bold" }}>群昵称</span>}
        visible={visibleView && false}
        onCancel={() => {
          setVisibleView(false);
          setAlias("");
        }}
        footer={modalFooter}
        wrapClassName="group-alias-modal"
      >
        <div>
          <TextArea
            rows={5}
            placeholder={t("please-enter-group-alias")}
            value={alias}
            maxLength={20}
            onChange={handleChangeGroupAlias}
            style={{
              border: " 1px solid @primary-color",
              borderRadius: "4px",
              resize: "none"
            }}
          />
          <div className="alias-tips">昵称修改后，只会在此群内显示，群内成员都可以看见。</div>
        </div>
      </Modal>
    </div>
  );
}

function mapStateToProps({ chat }: any) {
  const { selectedSession, customAppList, sessionMembers } = chat as ChatState;
  return { selectedSession, customAppList, sessionMembers };
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateSelectedSession(data: {}) {
      dispatch({ type: "chat/updateSelectedSession", payload: data });
    },
    async clearSessionMessage(data: { sessionId: string }) {
      await dispatch({ type: "chat/clearSessionMessage", payload: data });
      FocusSDK.sendIpcMessage("flashSessionForceClear", data);
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SessionSetting);
